import React, { useContext, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Loader from '../ui/loader.ui';

import { observer } from 'mobx-react-lite';
import { RootStoreContext } from '../core/root-store';
import HomeUi from './ui/home.ui';
import { useJobRole } from '../context/job-role.context';
import { trackPositionPageVisit } from '../analytics/analytics.service';

const Home = observer(() => {
  const rootStore = useContext(RootStoreContext);
  const userStore = rootStore.userStore;
  const isUserAuthenticated = userStore.isAuthenticated;
  const { jobRoleData, loading } = useJobRole();
  const { jobRoleId } = useParams();
  const location = useLocation();

  const isFounderRoute = location.pathname === '/founder';

  useEffect(() => {
    // Store currentJobRoleId for redirect
    if (!isUserAuthenticated && jobRoleId) {
      sessionStorage.setItem('currentJobRoleId', jobRoleId);
    }
  }, [isUserAuthenticated, jobRoleId]);

  useEffect(() => {
    if (jobRoleId && !loading) {
      trackPositionPageVisit();
    }
  }, [jobRoleId, loading]);

  if (!userStore.loaded || loading) {
    return (
      <Loader />
    );
  }

  return (
    <HomeUi
      isAuthenticated={isUserAuthenticated}
      jobRoleData={jobRoleData}
      jobRoleId={jobRoleId}
      isFounderRoute={isFounderRoute}
    />
  );
});

export default Home;
